module.exports = __webpack_public_path__ + "static/media/24UHCHR20.d79e1824.jpg";